import React from "react";
import { css, jsx } from "@emotion/react";
import getBadge from "./Badges";

const CommunityCard = ({ post, id }) => {
    const getBadgeBlog = (post) => {
                return (
                    <div>
                    <style jsx>
                        {`
                            .badge {
                                width: 8rem;
                                height: 8rem;
                                display: block;
                                border-radius: 100%;
                                background: url(${getBadge(post)}) no-repeat;
                                background-size: cover;
                                position: absolute;
                                top: 17rem;
                                right: 7rem;
                            }
                        `}
                    </style>
                    <div className="badge" />
                </div>)
    };

    return (
        <>
            <style jsx>
                {`
                    .indus {
                        color: #fc566f;
                    }

                    .rose {
                        display: block;
                        color: #fc566f;
                        margin: 1rem 0;
                        font-weight: 400;
                        text-align: center;
                    }
                    .wrapper {
                        background: #ffffff;
                        box-shadow: 7px 7px 0px 0px rgb(0 0 0 / 11%);
                        border-radius: 1rem;
                        width: 22rem;
                        position: relative;
                        max-height: 38rem;
                    }
                    .header-link {
                        color: #fff;
                        font-size: 1rem;
                        position: absolute;
                        left: 1rem;
                        top: 1rem;
                        line-height: normal;
                        font-weight: 400;
                    }
                    .f-img {
                        background-size: cover;
                        display: block;
                        width: 100%;
                        border-top-right-radius: 1rem;
                        border-top-left-radius: 1rem;
                        height: 21rem;
                    }
                    .header {
                        justify-content: center;
                        display: flex;
                        flex-wrap: wrap;
                        width: 100%;
                        padding: 2rem;
                        height: 14rem;
                        margin-top: 3rem;
                    }

                    .title {
                        font-family: Soleil;
                        font-size: 1.8rem;
                        line-height: normal;
                        color: #393972;
                    }
                    .desc {
                        font-size: 1.4rem;
                        color: #616161;
                        line-height: normal;
                        font-weight: 300;
                        text-align: center;
                    }
                    .author {
                        margin-top: 1.9rem;
                        margin-right: 1rem;
                        position: relative;
                    }
                    .a-img {
                        width: 6.1rem;
                        height: 6.1rem;
                        display: block;
                        border-radius: 100%;
                        border: 0.1rem solid #eee;
                        background-size: cover;
                    }
                    .a-name {
                        font-size: 1.5rem;
                        font-weight: bold;
                        color: #393972;
                        letter-spacing: 0;
                        margin-top: 2.3rem;
                        display: block;
                    }
                    .col {
                        flex: 1;
                    }
                    .wrap-card {
                        margin: 0 1rem;
                    }
                `}
            </style>
            <div className="wrap-card">
                <div className="item" key={"c" + id}>
                    <div className="wrapper">
                        <div className="header-link">
                            @{post.header_link}
                        </div>
                        {getBadgeBlog(post)}
                        <div>
                            <div
                                className="f-img"
                                style={{
                                    background: `url(${post.headImg}) no-repeat center center / cover`,
                                }}
                            />
                        </div>
                        <div className="header">
                            <h2 className="title">{post.name}</h2>
                            <p className="desc">
                                {post.desc}
                                <br />
                                <a href={post.url} className="rose">
                                    Explore Now
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CommunityCard;
